// Libellés des champs ajoutés aux appels de service saisis dans le portail.

export const APPLIANCE_TYPES = [
  { value: 'thermopompe', label: 'Thermopompe' },
  { value: 'climatiseur', label: 'Climatiseur' },
  { value: 'chauffage', label: 'Fournaise / chauffage' },
  { value: 'echangeur_air', label: "Échangeur d'air" },
  { value: 'electromenager', label: 'Électroménager' },
  { value: 'autre', label: 'Autre' },
];

export const applianceLabel = (value) => APPLIANCE_TYPES.find((type) => type.value === value)?.label || '';

// Code de priorité des appels : rouge, jaune, vert.
export const PRIORITIES = [
  { value: 'red', label: 'Rouge', hint: 'Urgent', dot: 'bg-red-500', badge: 'bg-red-100 text-red-700', button: 'bg-red-600 hover:bg-red-600 text-white' },
  { value: 'yellow', label: 'Jaune', hint: 'Prioritaire', dot: 'bg-yellow-400', badge: 'bg-yellow-100 text-yellow-800', button: 'bg-yellow-400 hover:bg-yellow-400 text-yellow-950' },
  { value: 'green', label: 'Vert', hint: 'Peut attendre', dot: 'bg-green-500', badge: 'bg-green-100 text-green-700', button: 'bg-green-600 hover:bg-green-600 text-white' },
];

// Les appels saisis avant le code de couleur pouvaient être marqués « urgent ».
export const priorityOf = (request) => request?.priority || (request?.urgency === 'urgent' ? 'red' : null);

export const priorityInfo = (request) => PRIORITIES.find((item) => item.value === priorityOf(request)) || null;

const RANK = { red: 0, yellow: 1, green: 2 };
const CLOSED = new Set(['completed', 'cancelled']);

const createdTime = (request) => {
  const time = Date.parse(request?.created_at || '');
  return Number.isNaN(time) ? 0 : time;
};

export const SORT_OPTIONS = [
  { value: 'priority', label: 'Priorité, puis plus ancien' },
  { value: 'oldest', label: 'Plus ancien d\'abord' },
  { value: 'newest', label: 'Plus récent d\'abord' },
];

// « priority » : appels ouverts d'abord, rouge → jaune → vert → sans couleur,
// et dans une même couleur le plus ancien (créé en premier) en haut.
export const sortRequests = (requests, mode = 'priority') => {
  const list = [...requests];
  if (mode === 'newest') return list.sort((a, b) => createdTime(b) - createdTime(a));
  if (mode === 'oldest') return list.sort((a, b) => createdTime(a) - createdTime(b));
  return list.sort((a, b) =>
    Number(CLOSED.has(a.status)) - Number(CLOSED.has(b.status))
    || (RANK[priorityOf(a)] ?? 3) - (RANK[priorityOf(b)] ?? 3)
    || createdTime(a) - createdTime(b));
};

// Date et heure de création, à l'heure du Québec.
export const formatCreated = (value) => {
  const time = Date.parse(value || '');
  if (Number.isNaN(time)) return '';
  return new Intl.DateTimeFormat('fr-CA', {
    timeZone: 'America/Toronto', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }).format(new Date(time));
};

export const isUrgent = (request) => priorityOf(request) === 'red';

export const warrantyLabel = (value) => {
  if (value === true) return 'Oui';
  if (value === false) return 'Non';
  return '';
};
